module.exports = __webpack_public_path__ + "static/img/img6.93e58c46.png";